module.exports = __webpack_public_path__ + "img/bar-chart-circle-03.cc91c801.svg";